import { useCallback, useState } from "react";

type JoyrideCallbackInput = {
  status?: string;
  type?: string;
  index?: number;
  action?: string;
};

export function useHrTour(storageKey: string) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const hasCompletedTour = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(storageKey) === "true";
  };

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const resetTour = useCallback(() => {
    setRun(false);
    setStepIndex(0);
    if (typeof window !== "undefined") {
      localStorage.removeItem(storageKey);
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data: JoyrideCallbackInput) => {
      const { status, type, index } = data;

      if (index !== undefined) setStepIndex(index);

      if (status === "finished" || status === "skipped" || type === "tour:end") {
        stopTour();
      }
    },
    [stopTour],
  );

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    resetTour,
    hasCompletedTour: hasCompletedTour(),
    handleJoyrideCallback,
  };
}

